import React, { useEffect, useState, useRef } from 'react';
import { trackPromise } from 'react-promise-tracker';
import Recaptcha from 'react-google-recaptcha';

import services from '../../../services';
import { useDispatch } from 'react-redux';
import {
  showMsgW as showMsgWAction,
  showMsgE as showMsgEAction,
  showMsgS as showMsgSAction,
} from '../../../store/actions/snackbarActions.js';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import './styles.scss';

import Modal from '../../../components/Modal/Modal';
import FormRegulamentoAuto from '../FormRegulamentoAuto';
import PasswordStrength from '../../../components/PasswordStrength';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';

import { getRegulamentoAtivo } from '../../../services/api-auto';
import globals from '../../../globals';
import DOMPurify from 'dompurify';

const sanitizeInput = (inputData) => {
  return DOMPurify.sanitize(inputData);
};

const RECAPTCHA_KEY = globals.REACT_APP_RECAPTCHA_KEY;

const InitialState = {
  nomeCompleto: '',
  cpf: '',
  email: '',
  celular: '',
  cargo: '',
  cnpj: '',
  senha: '',
  confirmarSenha: '',
  razaoSocial: '',
  cnpj: '',
  parceiroId: '',
  aceiteTermos: false,
};

const dataInit = {
  regulamentoId: null,
  titulo: '',
  conteudo: '',
  linkPdf: '',
  ativo: true,
  roles: [],
};

const FormCompletarCadastroParceiro = ({
  formParceiro,
  modalStatus,
  setModalStatus,
}) => {
  const recaptcha = useRef(null);
  const dispatch = useDispatch();
  const [indicarErros, setIndicarErros] = useState(false);
  const showMsgW = (msg) => {
    setIndicarErros(true);
    dispatch(showMsgWAction(msg));
  };
  const showMsgE = (msg) => {
    setIndicarErros(true);
    dispatch(showMsgEAction(msg));
  };
  const showMsgS = (msg) => {
    setIndicarErros(true);
    dispatch(showMsgSAction(msg));
  };

  const [dados, setDados] = useState(InitialState);
  const [perfis, setPerfis] = React.useState([]);
  const [regulamentoAuto, setRegulamentoAuto] = React.useState(false);
  const [checkedTermos, setCheckedTermos] = React.useState(false);
  const [cargo, setCargo] = React.useState([]);
  const [passwordStrength, setPasswordStrength] = React.useState(0);
  const [permiteEditarCargo, SetPermiteEditarCargo] = React.useState(true);

  const passwordSizeValidation = services.validate.validePasswordSize(
    dados.senha
  );
  const passwordNumberValidation = services.validate.validePasswordNumber(
    dados.senha
  );
  const passwordCapitalValidation = services.validate.validePasswordCapital(
    dados.senha
  );
  const passwordSpecialValidation = services.validate.validePasswordSpecial(
    dados.senha
  );

  React.useEffect(() => {
    let strength = 0;
    if (passwordSizeValidation) {
      strength++;
    }
    if (passwordNumberValidation) {
      strength++;
    }
    if (passwordCapitalValidation) {
      strength++;
    }
    if (passwordSpecialValidation) {
      strength++;
    }
    setPasswordStrength(strength);
  }, [dados.senha]);

  React.useEffect(() => {
    searchCpf();
  }, [dados.cpf]);

  const searchCpf = () => {
    if (services.validate.valideCpf(dados.cpf)) {
      if (recaptcha.current) {
        trackPromise(
          recaptcha.current
            .executeAsync()
            .then((recaptchaToken) => {
              services.storage.set('captcha', recaptchaToken);
              services.apiAuto
                .searchCpf({
                  cpf: services.mask.unMask(dados.cpf),
                })
                .then((res) => {
                  if (!res.fail) {
                    if (res.data !== null) {
                      setDados({
                        ...dados,
                        nomeCompleto: res.data.nomeCompleto,
                        email: res.data.email,
                        celular: res.data.phoneNumber,
                        cargo: res.data.nomePerfil,
                      });

                      SetPermiteEditarCargo(
                        res.data.nomePerfil !== 'Proprietário(a)'
                      );
                      SetPermiteEditarCargo(
                        res.data.nomePerfil == 'F&I' ||
                          res.data.nomePerfil == 'Vendedor(a)'
                      );

                      setCargo(res.data.nomePerfil);
                    }
                  } else {
                    setDados({
                      ...dados,
                      nomeCompleto: '',
                      email: '',
                      celular: '',
                      cargo: '',
                    });
                  }
                })
                .catch((error) => {
                  showMsgE(
                    error.errors.length ? error.errors[0].message : 'Error'
                  );
                });
            })
            .catch((error) => {
              console.log(error);
            })
        );
      }
    }
  };

  const changes = (event, campo) => {
    event.persist();
    let value = event.target.value;
    if (campo != null)
      setDados((prevstate) => ({
        ...prevstate,
        [campo]:
          campo == 'confirmarSenha' || campo == 'senha'
            ? value
            : sanitizeInput(value),
      }));
 
  };

  const handleAceiteTermosUso = (event) => {
    setCheckedTermos(event.target.checked);
    dados.aceiteTermos = event.target.checked;
  };

  const handleSelecionarCargo = (event) => {
    setCargo(sanitizeInput(event.target.value));
    dados.cargo = sanitizeInput(event.target.value);
  };

  useEffect(() => {
    getCargoList();
  }, []);

  const getCargoList = () => {
    trackPromise(
      services.apiAuto
        .perfis()
        .then((res) => {
          if (!res.fail) {
            setPerfis(res.data);
          } else {
            // setTimeout(getCargoList, 4000);
          }
        })
        .catch((error) => {
          // setTimeout(getCargoList, 4000);
        })
    );
  };

  useEffect(() => {
    getAtivo();
  }, []);

  const enviarDados = () => {
    if (
      !dados.nomeCompleto ||
      !dados.cpf ||
      !dados.email ||
      !dados.celular ||
      !dados.cargo ||
      !dados.senha ||
      !dados.confirmarSenha
    ) {
      showMsgW('Informe os campos obrigatórios');
      return;
    }
    if (!services.validate.valideCpf(services.mask.unMask(dados.cpf))) {
      showMsgW('Informe um CPF válido');
      return;
    }
    if (!services.validate.valideMail(dados.email)) {
      showMsgW('Informe um E-mail válido');
      return;
    }
    if (
      !services.validate.valideCellphone(services.mask.unMask(dados.celular))
    ) {
      showMsgW('Informe um número de celular válido');
      return;
    }
    if (!services.validate.validePasswordSize(dados.senha)) {
      showMsgW('Senha deve ter mínimo 8 caracteres');
      return;
    }
    if (!services.validate.validePasswordNumber(dados.senha)) {
      showMsgW('Senha deve ter ao menos 1 número');
      return;
    }
    if (!services.validate.validePasswordCapital(dados.senha)) {
      showMsgW('Senha deve ter letras maiúsculas e minúsculas');
      return;
    }
    if (!services.validate.validePasswordSpecial(dados.senha)) {
      showMsgW('Senha deve ter caracteres especiais');
      return;
    }
    if (dados.senha !== dados.confirmarSenha) {
      showMsgW('Senha e Confirme sua senha devem ser iguais');
      return;
    }
    if (!dados.aceiteTermos) {
      showMsgW('Necessário aceitar o regulamento para completar o cadastro');
      return;
    }

    setIndicarErros(false);

    let formatObt = {
      nome: dados.nomeCompleto,
      senha: dados.senha,
      confirmarSenha: dados.confirmarSenha,
      email: dados.email,
      cpf: services.mask.unMask(dados.cpf),
      phoneNumber: services.mask.unMask(dados.celular),
      aceiteRegulamento: dados.aceiteTermos,
      nomePerfil: dados.cargo,
      userName: services.mask.unMask(dados.cpf),

      cnpj: services.mask.unMask(formParceiro.documento),
      razaoSocial: dados.nomeCompleto,
    };

    if (recaptcha.current) {
      trackPromise(
        recaptcha.current
          .executeAsync()
          .then((recaptchaToken) => {
            services.storage.set('captcha', recaptchaToken);
            services.apiAuto
              .preCadastro(formatObt)
              .then((res) => {
                if (!res.fail) {
                  setModalStatus({
                    ...modalStatus,
                    primeiroAcesso: false,
                    conclusaoPreCadastro: true,
                  });
                } else {
                  if (res.errors == 'CPF já cadastrado.') {
                    showMsgW(res.errors);
                  } else {
                    showMsgE(
                      res.errors.message != null ? res.errors.message : 'Error'
                    );
                  }
                }
              })
              .catch((error) => {
                showMsgW('Erro ao concluir pré-cadastro');
                showMsgE(
                  error.errors.length ? error.errors[0].message : 'Error'
                );
              });
          })
          .catch((error) => {
            console.log(error);
          })
      );
    }
  };

  const [data, setData] = useState(dataInit);
  const [linkArquivo, setLinkArquivo] = useState('');

  const getAtivo = async () => {
    const reg = await getRegulamentoAtivo();
    setLinkArquivo(reg.data.linkPdf);
    setData(reg.data);
  };
  return (
    <Modal
      open={modalStatus.primeiroAcesso}
      close={() => {
        setModalStatus({ ...modalStatus, primeiroAcesso: false });
      }}
      size="lg"
    >
      <div className="formCompletarCadastroParceiro">
        <div className="container-fluid completarCadastroParceiroPage">
          <div className="row">
            <div className="col text-left">
              <h1>
                <b>Preencha os campos para se cadastrar.</b>
              </h1>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <Recaptcha
                ref={recaptcha}
                sitekey={RECAPTCHA_KEY}
                size="invisible"
              />
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="Nome completo"
                  type="text"
                  size="small"
                  onChange={(event) => changes(event, 'nomeCompleto')}
                  value={dados.nomeCompleto}
                  inputProps={{ maxLength: 100 }}
                  helperText={
                    indicarErros && !dados.nomeCompleto && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.nomeCompleto ? true : false}
                  variant="filled"
                />
              </FormControl>
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="CPF"
                  type="text"
                  size="small"
                  onChange={(event) => changes(event, 'cpf')}
                  value={services.mask.cpf(dados.cpf)}
                  helperText={indicarErros && !dados.cpf && 'Campo obrigatório'}
                  error={indicarErros && !dados.cpf ? true : false}
                  inputProps={{ maxLength: 14 }}
                  variant="filled"
                />
              </FormControl>
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="E-mail"
                  type="text"
                  size="small"
                  inputProps={{ maxLength: 100 }}
                  onChange={(event) => changes(event, 'email')}
                  value={dados.email}
                  helperText={
                    indicarErros && !dados.email && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.email ? true : false}
                  variant="filled"
                />
              </FormControl>
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="Telefone celular"
                  type="text"
                  size="small"
                  onChange={(event) => changes(event, 'celular')}
                  value={services.mask.celphone(dados.celular)}
                  helperText={
                    indicarErros && !dados.celular && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.celular ? true : false}
                  inputProps={{ maxLength: 15 }}
                  variant="filled"
                />
              </FormControl>
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="Cargo"
                  select
                  size="small"
                  onChange={handleSelecionarCargo}
                  value={cargo}
                  helperText={
                    indicarErros && !dados.roleId && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.cargo ? true : false}
                  variant="filled"
                  //disabled={!permiteEditarCargo}
                >
                  {perfis.map((option) => {
                    if (option) {
                      return (
                        <MenuItem
                          key={option.roleId}
                          value={option.displayName}
                        >
                          {option.displayName}
                        </MenuItem>
                      );
                    }
                  })}
                </TextField>
              </FormControl>
            </div>
            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="Senha"
                  type="password"
                  size="small"
                  onChange={(event) => changes(event, 'senha')}
                  value={dados.senha}
                  inputProps={{ maxLength: 20 }}
                  helperText={
                    indicarErros && !dados.senha && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.senha ? true : false}
                  variant="filled"
                />
              </FormControl>
            </div>

            <PasswordStrength password={dados.senha} />

            <div className="col-sm-12">
              <FormControl>
                <TextField
                  label="Confirme sua senha"
                  type="password"
                  size="small"
                  onChange={(event) => changes(event, 'confirmarSenha')}
                  value={dados.confirmarSenha}
                  inputProps={{ maxLength: 20 }}
                  helperText={
                    indicarErros && !dados.confirmarSenha && 'Campo obrigatório'
                  }
                  error={indicarErros && !dados.confirmarSenha ? true : false}
                  variant="filled"
                />
              </FormControl>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-12 acceptTermsWrapper">
              <Checkbox
                icon={<RadioButtonUnchecked />}
                checkedIcon={<RadioButtonChecked />}
                checked={checkedTermos}
                onChange={handleAceiteTermosUso}
                name="checkedPermission"
                inputProps={{ 'aria-label': 'primary checkbox' }}
                error={indicarErros && !dados.aceiteTermos ? true : false}
              />
              <label className="acceptTerms">
                Li e aceito o{' '}
                <a
                  className="linkRegulamento"
                  onClick={() => {
                    setRegulamentoAuto(true);
                  }}
                >
                  <b>
                    <u>regulamento</u>
                  </b>
                </a>
                &nbsp;do programa
              </label>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="padB20">
              <button
                className="btn btnFinalizarCadastro btn-lg btn-block"
                onClick={enviarDados}
              >
                Finalizar cadastro
              </button>
            </div>
          </div>
        </div>
        <Modal
          open={regulamentoAuto}
          close={() => {
            setRegulamentoAuto(false);
          }}
          size="lg"
        >
          <FormRegulamentoAuto linkArquivo={linkArquivo} />
        </Modal>
      </div>
    </Modal>
  );
};

export default FormCompletarCadastroParceiro;
